import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-busy"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "vld-background" }, null, -1)
const _hoisted_3 = { class: "vld-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error = _resolveComponent("error")!
  const _component_dots = _resolveComponent("dots")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        tabindex: "0",
        class: _normalizeClass(["vld-overlay is-active", { 'is-full-page': _ctx.isFullPage }]),
        "aria-busy": _ctx.isActive,
        "aria-label": "Loading"
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isErrored)
            ? (_openBlock(), _createBlock(_component_error, {
                key: 0,
                onRetryRequested: _ctx.requestRetry,
                errorMessage: _ctx.errorMessage
              }, null, 8, ["onRetryRequested", "errorMessage"]))
            : (_openBlock(), _createBlock(_component_dots, { key: 1 }))
        ])
      ], 10, _hoisted_1), [
        [_vShow, _ctx.isActive]
      ])
    ]),
    _: 1
  }))
}